export const ORGANIZATION_API_KEY = 'organization';
export const OTHER_KEY = 'otherOrganization';
export const UPDATE_KEY = 'updateOrganization';
export const REMOVE_CONTACT_KEY = 'removeContact';
export const REF_DATA_MAP = {municipality: 'KUNTA'};
export const ECOSYSTEM_API_KEY = '_ecosystem_serviceprovider_consent_api_path';
export const FETCH_ORGANIZATION_PROFILE_KEY = 'organizationProfileData';
export const FETCH_CONTACT_EVENT_KEY = 'employerContactEventData';
